import React, { PropTypes, Component } from 'react';

export default class Repos extends Component {
  render () {
    return (
      <div>
        {this.props.results.map((currentVal, i) =>
          <div className="repo-item" key={i}>
            <a href={currentVal.html_url}>{currentVal.name}</a><br/>
            {currentVal.description}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/about/Repos.js